<template>
  <div class="template">

    <div class="tabs">
      <div class="tab" v-for="tab in tabs" @click="openTab(tab.route)" :class="{isActive: tab.route == tabRoute}">
        <h4>{{tab.readable}}</h4>
      </div>
    </div>

    <div class="container">

      <div class="containerInner">

        <div class="columnLeft">
        </div>

        <div class="columnCenter">

          <div class="content">

            <component :is="tab" class="component"></component>

          </div>

        </div>

        <div class="columnRight">
        </div>

      </div>

    </div>

  </div>
</template>

<script>

import DJHome from './tabs/DJHome'
import DJPerspectives from './tabs/DJPerspectives'
import DJTimeline from './tabs/DJTimeline'
import DJMap from './tabs/DJMap'
import DJFulltext from './tabs/DJFulltext'
import DJSources from './tabs/DJSources'

export default {
  name: 'DrottningensJuvelsmycke',
  readable: 'Drottningens juvelsmycke',
  route: 'drottningens-juvelsmycke',
  data () {
    return {
      tabs: [
        DJHome,
        DJPerspectives,
        DJTimeline,
        DJMap,
        DJFulltext,
        DJSources
      ]
    }
  },
  computed: {
    tabRoute: function () {
      return this.$route.params['tabRoute'] ? this.$route.params['tabRoute'] : this.tabs[0].route;
    },
    tab: function () {
      return this.$route.params['tabRoute'] ? this.tabs.filter(t => t.route == this.$route.params['tabRoute'])[0] : this.tabs[0];
    }
  },
  methods: {
    openTab: function (route) {
      this.$router.push({ params: { tabRoute: route }})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.template{
  position: relative;
  /*display: flex;
  flex-direction: column;*/
}

.border{
  border: 1px solid gray;
}

.container{
  min-height: 100vh;
  background: url('/static/graphics/DJbg.png');
  background-size: contain;
  background-position: top center;
  background-repeat: repeat;
  padding: 10px;
  box-sizing: border-box;
}

.tabs{
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
  z-index: 5;
}

.tab{
  flex: 1 1 auto;
  text-align: center;
  padding: 20px;
  border-left: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
  background: white;
  cursor: pointer;
  box-sizing: border-box;
}

.tab:first-child{
  font-weight: bold;
  border-left: 0;
}

.tab.isActive{
  background: rgb(230,230,230);
}

.tab:hover{
  background: rgb(240,240,240);
}

.content{
  background: rgba(255,255,255,0.95);
  padding: 20px;
  border-radius: 2px;
  margin: 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/objects/drottningensjuvelsmycke/DJLanding.vue